import React from "react"
import {InnerWrapper} from "./components"

export type ClubInnerWrapperProps = {
    children: React.ReactNode
}

const ClubInnerWrapper = ({children}: ClubInnerWrapperProps) => (
    <InnerWrapper data-testid="header-secure-header-inner-wrapper">{children}</InnerWrapper>
)

export default ClubInnerWrapper
